import { withNamespaces } from 'react-i18next';
import {
    Button,
    Col,
    Spinner,
} from 'reactstrap';

const ComposeActions = ({
    t,
    isSending,
    onDiscard,
}) => {
    return (
        <Col sm="12" className="d-flex justify-content-end">
            <Button
                type="button"
                color="secondary"
                outline
                className="me-2"
                disabled={isSending}
                onClick={onDiscard}
            >
                {t('Discard')}
            </Button>
            <Button
                type="submit"
                color="primary"
                disabled={isSending}
            >
                {isSending && (
                    <Spinner
                        size="sm"
                        className="me-2"
                    />
                )}
                {t('Send')}
            </Button>
        </Col>
    );
};

export default withNamespaces()(ComposeActions);
